module.exports = __webpack_public_path__ + "static/img/bids_received_image.7590fd52.png";